import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Textarea,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Link,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import {useState} from "react";
import {FiPhone} from "react-icons/fi";

export default function CancelAppointmentModal({
  isOpen,
  onClose,
  appointment,
  canModify,
  blockedMessage,
  clinicPhone,
  onConfirm,
  isLoading,
}) {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (reason.trim() === "") return;
    await onConfirm(reason);
  };

  // If blocked, show the blocked message
  if (!canModify) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Unable to Cancel Online</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Alert status="warning" borderRadius="md" flexDirection="column" alignItems="start">
              <AlertIcon />
              <AlertTitle mt={2}>Time Restriction</AlertTitle>
              <AlertDescription mt={2}>
                {blockedMessage}
              </AlertDescription>
            </Alert>
            {clinicPhone && (
              <Box mt={4} p={4} bg="gray.50" borderRadius="md">
                <Text fontWeight="semibold" mb={2}>Contact the clinic:</Text>
                <Link href={`tel:${clinicPhone}`} color="blue.500" display="flex" alignItems="center" gap={2}>
                  <FiPhone />
                  {clinicPhone}
                </Link>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }

  // Normal cancel flow
  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cancel Appointment</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Box>
                <Text fontWeight="semibold">{appointment?.service}</Text>
                <Text fontSize="sm" color="gray.600">
                  {appointment?.date} at {appointment?.time}
                </Text>
              </Box>
              <Alert status="warning" borderRadius="md">
                <AlertIcon />
                <Text fontSize="sm">
                  Are you sure you want to cancel this appointment? This action cannot be undone.
                </Text>
              </Alert>
              <FormControl isRequired>
                <FormLabel>Reason for cancellation</FormLabel>
                <Textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Please provide a reason for cancelling..."
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter gap={2}>
            <Button variant="ghost" onClick={handleClose}>
              Keep Appointment
            </Button>
            <Button
              colorScheme="red"
              type="submit"
              isLoading={isLoading}
              isDisabled={reason.trim() === ""}
            >
              Cancel Appointment
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
